module.exports = __webpack_public_path__ + "img/v4_adminLanguageService.802dd9dc.png";